import React, { useEffect, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { SingleSelect } from '../select-types/SingleSelect.js';
import { UtilService } from '../../services/UtilService.js';
import Excel from './Excel.js';
import { Item } from '../../models.ts';
import EditCalculator from './EditCalculator.js';

const GarageCalculator = ({ garageObj, garageMap, isAdmin, handleSubmit }) => {
  const [garageState, setGarageState] = useState({});
  const [disableCalculate, setDisableCalculate] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const utilService = new UtilService();

  useEffect(() => {
    if (garageObj && garageMap) {
      let obj = { ...garageObj };
      garageObj.fields.forEach(field => {
        obj[field.id] = { ...field };
      });
      setGarageState(obj);
    }
    return () => {
      setGarageState({});
      setDisableCalculate(true);
    };
  }, [garageObj, garageMap]);

  function handleChange(field, value) {
    switch (field.type) {
      case 'select':
        let item = garageMap[field.collection].find(i => i.id === value);
        field.selection = JSON.parse(JSON.stringify(item));
        break;
      case 'text':
      case 'number':
        if (!field.selection) {
          field.selection = new Item();
        }
        field.selection.value = field.type === 'number' ? Number(value) : value;
        break;
      default:
        break;
    }
    setGarageState({ ...garageState, [field.id]: { ...field } });
    checkDisabled();
  }

  function checkDisabled() {
    let disabled = false;
    if (garageState?.fields?.length) {
      for (let field of garageState.fields) {
        if (garageState[field.id].show && garageState[field.id].required && !disabled) {
          if (field.type === 'select') {
            disabled = garageState[field.id].selection === undefined;
          } else if (field.type === 'text') {
            disabled = !garageState[field.id].selection?.value?.length;
          } else if (field.type === 'number') {
            disabled = !garageState[field.id].selection?.value || garageState[field.id].selection?.value === 0;
          }
        }
      }
    }
    setDisableCalculate(disabled);
  }

  function calculate() {
    let newObj = handleSubmit(garageState, garageMap);
    setGarageState({ ...newObj });
  }

  function onEdit() {
    document.getElementById('container').style.width = isEditing ? '300px' : '90vw';
    setIsEditing(!isEditing);
  }

  if(isEditing) {
    return (
      <EditCalculator title={'Garage Calculator'}
        calculator={garageState}
        itemList={garageMap}
        onFinish={onEdit}
      />
    )
  } else {
    return (
      <div>
        <div>
          {isAdmin &&
            <Button variant='outlined' onClick={onEdit}>
              {isEditing ? 'Done' : 'Edit'}
            </Button>
          }
          <h1>Garage Calculator</h1>
        </div>
        <div>
          {garageState.fields?.length &&
            garageState.fields.map(field => {
              if (garageState[field.id].show) {
                return (
                  <div key={field.id}>
                    {field.type === 'select' &&
                      <SingleSelect
                        field={garageState[field.id]}
                        label={field.name}
                        optionList={garageMap[field.collection]}
                        handleChange={handleChange}>
                      </SingleSelect>
                    }
                    {(field.type === 'text' || field.type === 'number') &&
                      <TextField
                        error={garageState[field.id].required &&
                          (!garageState[field.id].selection?.value || garageState[field.id].selection?.value === 0)}
                        label={field.name}
                        defaultValue={garageState[field.id].value || ''}
                        helperText={null}
                        required={field.required}
                        onChange={(e) => handleChange(field, e.target.value)}
                        variant="standard"
                      />
                    }
                    {!field.type &&
                      <div className='total'>
                        <span>{field.name} = </span>
                        <span>{utilService.formatCurrency(garageState[field.property]) || 0}</span>
                      </div>
                    }
                  </div>
                )
              } else {
                return (null)
              }
            })
          }
        </div>
        <div className='buttonGroupSpaced'>
          <Button variant="outlined"
            onClick={calculate}
            disabled={disableCalculate}
          >
            Calculate
          </Button>
          {!disableCalculate && garageState.total > 0 &&
            <Excel calc={garageState}></Excel>
          }
        </div>
      </div>
    )
  }
};

export default GarageCalculator;